module.exports = __webpack_public_path__ + "img/diffuser_round.050b2560.svg";